var exports = {
  "oN": "ComposerInline.module__customEmoji___RDhSNm",
  "wh": "ComposerInline.module__plainText___RDhSNm",
  "eu": "ComposerInline.module__literal___RDhSNm",
  "p6": "ComposerInline.module__spoiler___RDhSNm",
  "sM": "ComposerInline.module__srOnly___RDhSNm",
};

module.exports = exports;
